/** Figma 3182:16627 — the pill and its shadow, shared with the other gates. */
const CTA_CLASS =
    'flex h-14 w-full items-center justify-center rounded-full bg-[#181818] text-xl font-medium tracking-[-0.02em] text-[#f3f3f3] shadow-[0_0.1875rem_0.8125rem_0_rgba(0,0,0,0.25),0_1.25rem_2.125rem_0_rgba(0,0,0,0.25)] transition-colors hover:bg-[#2c2c2c]';

export interface SubscribeSuccessProps {
    /**
     * The account step to offer, or null for a reader who already has a session —
     * pitching an account at someone signed in reads as though we did not notice.
     */
    account: {
        /** "Create an ArchiPro Account", or "Log in" when the address is known. */
        label: string;
        heading: string;
        body: string;
        onSelect: () => void;
    } | null;
    /** Dismiss and stay where they were. */
    onDismiss: () => void;
}

/**
 * Success step of the subscribe gate: the subscription has landed, and — for a
 * reader who has no session — an account is offered as the next thing rather
 * than a requirement.
 *
 * The pitch is deliberately below the confirmation. The reader came to
 * subscribe, they have, and this is an offer they can walk past.
 */
export const SubscribeSuccess = ({
    account,
    onDismiss,
}: SubscribeSuccessProps) => (
    <div className="flex size-full flex-col">
        <h2 className="m-0 text-[2.0625rem] leading-[2.125rem] font-medium tracking-[-0.02em] text-[#181818]">
            Success! You&rsquo;re subscribed.
        </h2>

        {account ? (
            <>
                <div className="mt-auto">
                    <p className="m-0 text-[1.1875rem] leading-normal font-medium tracking-[-0.02em] text-[#181818]">
                        {account.heading}
                    </p>
                    <p className="m-0 mt-1 text-[1.1875rem] leading-normal tracking-[-0.02em] text-[#828282]">
                        {account.body}
                    </p>
                </div>
                <button
                    type="button"
                    onClick={account.onSelect}
                    className={`mt-8 ${CTA_CLASS}`}
                >
                    {account.label}
                </button>
                <button
                    type="button"
                    onClick={onDismiss}
                    className="mt-4 text-center text-[1.0625rem] tracking-[-0.02em] text-[#44443f]"
                >
                    Not right now
                </button>
            </>
        ) : (
            <>
                <p className="m-0 mt-auto text-[1.1875rem] leading-normal tracking-[-0.02em] text-[#828282]">
                    The next issue will land in your inbox. You can change what
                    you receive any time from your account.
                </p>
                <button
                    type="button"
                    onClick={onDismiss}
                    className={`mt-8 ${CTA_CLASS}`}
                >
                    Done
                </button>
            </>
        )}
    </div>
);
